import React, { Component } from 'react';
import VsfModal from "../components/listaddons/VsfModal";
import { observer } from "mobx-react";

@observer
export default class RightModalInList extends Component {


    onCloseModal() {
        if (this.props.onCloseModal!=null) {
            this.props.onCloseModal();
        } else {
            this.props.modalState.modalOpen=false;
        }
    }

    onSaveButton() {
        this.props.listComponent.onClickSaveQuickEdit();
    }

    render() {
        return (
            <VsfModal
                stateFilter={this.props.modalState}
                isOpen={this.props.isOpen}
                className="right-to-left"
                onCloseModal={()=>this.onCloseModal()}
            >
                {this.props.children}
            </VsfModal>
        )
    }
}
